import React from "react";
import { Redirect, useLocation, matchPath } from "react-router-dom";
import { useGlobal } from "reactn";
import { useLoginState } from "@ugg/shared/hooks/use-user-hooks";
import { useRsoConnection } from "@ugg/shared/api/requests/accounts/oauth-hooks";
import { AppRoutes, getProfileYearInReviewUrl } from "@ugg/shared/routes/app-routes";

interface ProfileParams {
  region: string;
  riotUserName: string;
  riotTagLine: string;
}

export const YearInReviewAuthRouter = () => {
  const location = useLocation();
  const isLoggedIn = useLoginState();
  const [loggingIn] = useGlobal("loggingIn");
  const { summoner, hasRsoConnection, loading: loadingRso } = useRsoConnection();

  const yearInReviewMatch = matchPath<ProfileParams>(location.pathname, {
    path: AppRoutes.PROFILE_YEAR_IN_REVIEW,
    exact: true,
    strict: false,
  });

  const isOnProfilePage = !!yearInReviewMatch;
  const profileParams = yearInReviewMatch?.params;

  if (loggingIn || loadingRso) {
    return null;
  }

  if (!isLoggedIn) {
    if (isOnProfilePage && profileParams) {
      const { region, riotUserName, riotTagLine } = profileParams;
      return <Redirect to={getProfileYearInReviewUrl(region, riotUserName, riotTagLine)} />;
    }

    return (
      <Redirect
        to={{
          pathname: AppRoutes.LOGIN,
          search: `redirect_url=${encodeURIComponent(AppRoutes.YEAR_IN_REVIEW)}`,
        }}
      />
    );
  }

  const { riotUserName: userRiotUserName, riotTagLine: userRiotTagLine, regionId: userRegionId } = summoner || {};
  if (!hasRsoConnection || !userRiotUserName || !userRiotTagLine || !userRegionId) {
    return <Redirect to={AppRoutes.VERIFICATION} />;
  }

  if (isOnProfilePage && profileParams) {
    const { region, riotUserName, riotTagLine } = profileParams;
    return <Redirect to={getProfileYearInReviewUrl(region, riotUserName, riotTagLine)} />;
  }

  return <Redirect to={getProfileYearInReviewUrl(userRegionId, userRiotUserName, userRiotTagLine)} />;
};
